( () => {
    "use strict";
    var t = {
        420: t => {
            t.exports = JSON.parse('{"siteName":"ss-unbxd-prod-supertails43231684495044","sdkVersion":"v6.3.2"}')
        }
    }
      , e = {};
    const r = {
        facets: [{
            elemWrapper: '[aria-label="Filters"] .UNX-text-facet-wrap',
            triggers: {
                facetElem: '[aria-label="Filters"] .UNX-text-facet-wrap .UNX-change-facet , [aria-label="Filters"] .UNX-text-facet-wrap .UNX-range-slider-wrap',
                clearAll: ".UNX-text-facet-wrap .UNX-facet-clear"
            },
            selected: {
                selector: '[aria-label="Filters"] .UNX-text-facet-wrap .UNX-change-facet.UNX-selected-facet-btn'
            },
            name: {
                selector: '[aria-label="Filters"] .UNX-text-facet-wrap .UNX-facet-header h3'
            },
            value: {
                selector: '[aria-label="Filters"] .UNX-text-facet-wrap .UNX-change-facet .UNX-facet-text , [aria-label="Filters"] .UNX-text-facet-wrap .slider__labels-item'
            },
            facetCB: {
                onFacetClick: ({name: t}) => {
                    if ("Price" === t) {
                        const t = document.querySelector(".noUi-handle-lower")
                          , e = document.querySelector(".noUi-handle-upper");
                        if (t && e) {
                            const r = t.getAttribute("aria-valuenow")
                              , a = e.getAttribute("aria-valuenow");
                            if (r && a)
                                return {
                                    facets: {
                                        price: [`${r} TO ${a}`]
                                    }
                                }
                        }
                    }
                }
                ,
                onPreSelectedAtURL: () => {
                    const t = new URLSearchParams(window.location.search)
                      , e = {};
                    return t.forEach(( (t, r) => {
                        if (r.endsWith("_uFilter")) {
                            const a = r.replace("_uFilter", "")
                              , c = t.split(",").map((t => t.trim()));
                            e[a] || (e[a] = []),
                            e[a].push(...c)
                        }
                    }
                    )),
                    {
                        facets: e
                    }
                }
            }
        }],
        search: {
            inputBox: ".site-header__search-form #mainfrm",
            queryBtn: ".show_on_compres .site-header__search-form button[type='submit']",
            urlParam: "q"
        },
        pageView: {
            delay: 1500,
            events: {
                home: {
                    uniqueSelectors: {
                        selectors: [".home-page-sales-section"]
                    },
                    urlIdentifiers: {
                        urls: ["https://supertails.com/", "https://supertails.com"],
                        exactMatch: !0
                    }
                },
                search: {
                    uniqueSelectors: {
                        selectors: ["#searchResultsWrapper li[data-id]"]
                    },
                    urlIdentifiers: {
                        urls: ["/search"],
                        exactMatch: !1
                    },
                    searchRecall: {
                        noOfResultsSelector: ".unbxd-suggestion-block .searched-count"
                    }
                },
                category: {
                    debounceDelay: 1e3,
                    uniqueSelectors: {
                        selectors: ["body.template-collection"]
                    },
                    urlIdentifiers: {
                        urls: ["/collections"],
                        exactMatch: !1
                    }
                },
                productDisplay: {
                    uniqueSelectors: {
                        selectors: [".template-product"]
                    },
                    urlIdentifiers: {
                        urls: ["/products/"],
                        exactMatch: !1
                    }
                },
                cart: {
                    uniqueSelectors: {
                        selectors: ["body.template-cart"]
                    },
                    urlIdentifiers: {
                        urls: ["/cart"],
                        exactMatch: !1
                    }
                },
                order: {
                    urlIdentifiers: {
                        urls: ["/thank_you", "/orders"],
                        exactMatch: !1
                    }
                }
            }
        }
    }
      , a = function r(a) {
        var c = e[a];
        if (void 0 !== c)
            return c.exports;
        var i = e[a] = {
            exports: {}
        };
        return t[a](i, i.exports, r),
        i.exports
    }(420)
      , c = a.sdkVersion;
    window.UnxAnalyticsConfig = r,
    window.UnxAnalyticsConfig.metaData = {
        siteName: a.siteName
    };
    const i = document.createElement("script");
    i.src = `https://libraries.unbxdapi.com/ua/${c}/uaLibrary.js`,
    document.head.appendChild(i)
    }
)();